import React from 'react';
import PropTypes from 'prop-types';
import { registerDecoration } from 'core/forms';

import { createIconComponent } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/formDecorationPropertiesUpsell.module.scss';

const FormDecorationPropertiesUpsell = ({
  fieldId,
  schema,
}) => (
  <div className={styles.element} id={fieldId}>
    {createIconComponent({ icon: schema.icon, size: 32 })}
    <div className={styles.content}>
      <Typo className={styles.title} variant="s03" weight="bold">{schema.title}</Typo>
      <Typo variant="b01">{schema.description}</Typo>
    </div>
  </div>
);

FormDecorationPropertiesUpsell.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({}).isRequired,
};

registerDecoration('PropertiesUpsell', React.memo(FormDecorationPropertiesUpsell));

export default FormDecorationPropertiesUpsell;
